import * as React from 'react';
import { cn, getText, getConfig } from '../../helpers';
import LinkListLarge from '../_common/link-list-large';
import CustomLink from '../_common/custom-link';
import HtmlContent from '../_common/html-content';

import './research-section.style.scss';

const readMoreTitle = getText('pages.home.seeMoreLinkTitle');

function ResearchSection(props: ResearchSectionProps) {
    const { snippet, articleLinks, readMoreLink, linkText } = props;
    const hasArticles = articleLinks && articleLinks.length;

    return snippet && readMoreLink ? (
        <section
            className={cn('research-section page-section', {
                'research-section--expanded': !hasArticles
            })}
        >
            <div className="research-section__inner page-section__inner">
                <div className="research-section__intro">
                    <HtmlContent html={snippet} />
                    <CustomLink url={readMoreLink} text={linkText} linkTheme="alternative" hasIcon isUpperCase title={readMoreTitle} />
                </div>
                {articleLinks && (
                    <LinkListLarge list={articleLinks} maxLength={getConfig('routes.homepage.numberOfResearchItems')} className="research-section__list" />
                )}
            </div>
        </section>
    ) : null;
}

export default React.memo(ResearchSection);
